import ModuleTitle from './ModuleTitle.vue';
import Tip from './ImageTip.vue';
import { ArrowRightOutlined } from '@ant-design/icons-vue';
import { defineComponent } from 'vue';
export default defineComponent({
  components: {
    ModuleTitle: ModuleTitle,
    Tip: Tip,
    ArrowRightOutlined: ArrowRightOutlined
  }
});